// extracted by mini-css-extract-plugin
export default {"root":"ReplyEditor_root__AVWFn","textarea":"ReplyEditor_textarea__z3o+x","buttons":"ReplyEditor_buttons__sH6Dt","form":"ReplyEditor_form__mcP9g"};